import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalVariables } from '../../../global-variables';
import { observableToBeFn } from 'rxjs/internal/testing/TestScheduler';


@Injectable({
  providedIn: 'root'
})
export class VcardUserService {

  //  Change base URL as per your API
  private baseUrl = `${GlobalVariables.vcardURL}users`;

  constructor(private http: HttpClient) {}
  // =========================================================
  //  BASIC CRUD
  // =========================================================

  //  GET ALL USERS (company-based)
  getAll(companyId?: string): Observable<any> {
    let url = this.baseUrl;

    if (companyId) {
      url += `?companyId=${companyId}`;
    }

    return this.http.get<any>(url);
  }

  //  GET USER BY ID
  getById(id: string): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/${id}`);
  }

  //  CREATE USER
  create(data: any) {
    const payload = {
        name: data.name,
        email: data.email,
        password: data.password,
        roleId: data.roleId, 
        companyId: data.companyId,
        customFields: data.customFields || {},
        createdAt: new Date().toISOString(),
        userType: 'BI'  // type for generating business users
    };

    return this.http.post<any>(this.baseUrl, payload);
   }

  //  UPDATE USER
  update(id: string, data: any): Observable<any> {
    return this.http.patch<any>(`${this.baseUrl}/${id}`, data);
  }

  // update user status
  updateStatus(id: string, data: any): Observable<any> {
    return this.http.patch<any>(`${this.baseUrl}/${id}/status`, data);
  }
  //  DELETE USER
  delete(id: string): Observable<any> {
    return this.http.delete<any>(`${this.baseUrl}/${id}`);
  }

  //resned email
  sendEmail(id:string) :Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/${id}/resend-email`,null);
  }

  // =========================================================
  //  ROLE + HIERARCHY BASED
  // =========================================================

  //  GET USERS BY ROLE
  getByRole(roleId: string): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}?roleId=${roleId}`);
  }

  //  GET USERS UNDER MANAGER
  getTeam(managerId: string): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}?managerId=${managerId}`);
  }

  //  GET USERS BY COMPANY + ROLE LEVEL
  getByLevel(companyId: string, level: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseUrl}?companyId=${companyId}&level=${level}`
    );
  }

  // =========================================================
  //  CONTACT ASSIGNMENT (IMPORTANT FOR CRM)
  // =========================================================

  //  ASSIGN CONTACT TO USER
  assignContact(data: any): Observable<any> {
    /*
      {
        contactId,
        assignedTo (userId)
      }
    */
    return this.http.post<any>(`${this.baseUrl}/assign-contact`, data);
  }

  // =========================================================
  //  AUTH / PROFILE
  // =========================================================

  //  LOGIN
  login(data: any): Observable<any> {
    /*
      {
        email,
        password
      }
    */
    return this.http.post<any>(`${this.baseUrl}/login`, data);
  }

  //  GET CURRENT USER PROFILE
  getProfile(): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/profile`);
  }

  //  UPDATE PROFILE
  updateProfile(data: any): Observable<any> {
    return this.http.put<any>(`${this.baseUrl}/profile`, data);
  }

  //check user

  checkuser(data:any): Observable<any> {
    return this.http.post<any>(`${GlobalVariables.vcardURL}/auth/check-user`,data);
  }

  //generate token

  generateToken(data:any): Observable<any> {
    return this.http.post<any>(`${GlobalVariables.vcardURL}/auth/generate-token`,data);
  }

}